import React from "react";

import { Icon, Spin } from "components";

/**
 *
 * @param {string} status ["actionable","review"], background white if not passed
 * @param {boolean} disabled Overrides status
 * @param {boolean} loading Overrides status
 * @param {string} iconName Icon name of the module
 *
 * @returns {ReactElement} ModuleIconStatus
 */
export const ModuleIconStatus = ({ status, disabled, loading, icon, style }) => (
  <span style={style} className={`module-icon-status ${status} ${disabled ? "disabled" : ""} ${loading ? "loading" : ""}`}>
    {loading ? <Spin iconName="tabler/loader" /> : <Icon iconName={icon} className="icon inline" />}
  </span>
);
